import api from "./axios";

// Groups API service
export const groupsApi = {
  // Get all groups with optional search and filters
  getAll: async (search = "", clientFilter = []) => {
    const params = new URLSearchParams();
    if (search) params.append("search", search);
    if (clientFilter.length > 0) {
      clientFilter.forEach((id) => params.append("clientFilter", id));
    }

    const response = await api.get(`/groups?${params.toString()}`);
    return response.data;
  },

  // Get group by ID
  getById: async (id) => {
    const response = await api.get(`/groups/${id}`);
    return response.data;
  },

  // Create new group
  create: async (groupData) => {
    const response = await api.post("/groups", groupData);
    return response.data;
  },

  // Update group
  update: async (id, groupData) => {
    const response = await api.put(`/groups/${id}`, groupData);
    return response.data;
  },

  // Delete group
  delete: async (id) => {
    const response = await api.delete(`/groups/${id}`);
    return response.data;
  },

  // Get operators for assignment
  getOperators: async (isActive = true) => {
    const response = await api.get(`/operators?isActive=${isActive}`);
    return response.data;
  },

  // Get clients for assignment
  getClients: async () => {
    const response = await api.get("/clients");
    return response.data;
  },

  // Get operators by group ID
  getOperatorsByGroupId: async (groupId) => {
    const response = await api.get(`/groups/${groupId}/operators`);
    return response.data;
  },
};

export default groupsApi;
